import React from 'react';
export function ViewClassroomVideo({ link }: { link: string }) {
  return (
    <div className='w-full  max-w-[700px] aspect-video bg-black'>
      {/* <img src={import('../../../assets/video.png')} className='object-contain w-full h-full' /> */}
      <video controls autoPlay loop src={link} className='object-contain w-full h-full ' />
    </div>
  );
}
